<template>
  <div class="view-product-register-module-quiz">
    <div v-if="!!product">
      <h1 class="page-title">
        Cadastrar módulo
      </h1>
      <div class="row">
        <div class="col-lg-4">
          <steps
            :step="currentStep"
            :names="[
              'Configurações Básicas',
              'Adicionar Conteúdo',
              'Perguntas do QUIZ'
            ]"
          />
        </div>
        <div class="col-lg-8">
          <button class="btn" @click="$router.go(-1)">
            <h5 class="text-dark">
              <i class="icon-angle-left mr-3" /> Adicionar QUIZ
            </h5>
          </button>
          <hr />
          <h6 class="secondary-title-subtitle mb-6">
            Tipo de QUIZ
            <small>
              Configure o QUIZ que será exibido para seus alunos.
            </small>
          </h6>
          <form-group
            v-model="form.exercise"
            id="form.exercise"
            :options="[{ name: 'Exercício/Teste' }]"
            type="radio"
            :errors="errors.exercise"
          />
          <div class="pl-5">
            <small class="small-text text-secondary mb-6">
              Crie um Quiz com questões de múltipla escolha e respostas únicas.
              Ao final, seu aluno receberá o resultado através de uma nota.
            </small>
          </div>
          <form-group
            class="pt-5"
            v-model="form.profile"
            id="form.profile"
            :options="[{ name: 'Perfil' }]"
            type="radio"
            :errors="errors.profile"
          />
          <div class="pl-5">
            <small class="small-text text-secondary mb-6">
              Crie um Quiz com questões de múltipla escolha. Os resultados serão
              personalizados de acordo com os perfis que você criar para as
              respostas dos usuários.
            </small>
          </div>
          <form-group
            v-model="form.name"
            id="form.name"
            placeholder="Ex: Apresentação do curso"
            label="Nome do QUIZ"
            class="pt-5"
          />
          <div class="form-group pt-6 mb-6">
            <label>Descrição do QUIZ</label>
            <wysiwyg />
          </div>
          <hr />
          <h6 class="secondary-title-subtitle mb-6">
            Liberação do conteúdo
            <small>
              Determine em quantos dias o seu conteúdo será liberado após a
              compra.
            </small>
          </h6>

          <form-group
            v-model="form.enableDaysCount"
            id="enableDaysCount"
            :options="[{ name: 'Liberar após quantidade de dias' }]"
            type="radio"
            :errors="errors.enableDaysCount"
          />
          <div v-if="form.enableDaysCount" class="row">
            <div class="col-lg-3">
              <form-group
                v-model="form.daysCount"
                id="form.enableDaysCount"
                placeholder="0 dias"
                label="Liberar após"
              />
            </div>
          </div>
          <form-group
            v-model="form.enableDaysCount"
            id="enableDaysCount"
            :options="[{ name: 'Liberar por datas específicas' }]"
            type="radio"
            :errors="errors.enableDaysCount"
            class="mb-5"
          />
          <hr />
          <h6 class="secondary-title-subtitle mb-3">
            Duração de acesso ao conteúdo
          </h6>
          <div class="d-flex align-items-center">
            <form-group
              class="mr-5"
              v-model="form.unlimitedDuration"
              :id="form.unlimitedDuration"
              type="checkbox"
            />
            <p class="pt-5">Este conteúdo tem duração limitada</p>
          </div>

          <div class="row pt-6">
            <div class="col-lg-6 mb-5">
              <button
                class="btn btn-block btn-outline-secondary"
                @click="$router.go(-1)"
              >
                Cancelar
              </button>
            </div>
            <div class="col-lg-6">
              <router-link
                class="btn btn-block btn-primary"
                :class="{ 'btn-secondary': !canMoveFoward }"
                :disabled="!canMoveFoward"
                :to="{
                  name: 'product-module-quiz-add-question',
                  params: { id: $route.params.id }
                }"
              >
                Avançar
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Steps from "@/components/product/Steps";
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    Steps
  },
  data() {
    return {
      ...formFields(
        [
          "name",
          "enableDaysCount",
          "daysCount",
          "unlimitedDuration",
          "complementary_reading",
          "complementary_readings",
          "complementary_files",
          "enableDurationAccess"
        ],
        {
          complementary_reading: {
            title: "",
            site_name: "",
            url: "",
            editedIndex: undefined
          },
          complementary_files: []
        }
      ),
      visible: {
        complementary_reading: false,
        file_upload: false
      },
      currentStep: 2
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    canMoveFoward() {
      const can = true;
      return can;
    }
  },
  methods: {
    previous() {
      this.currentStep -= 1;
    },
    next() {
      this.currentStep += 1;
    },
    onSaveReadings() {
      const { complementary_reading, complementary_readings } = this.form;
      if (Array.isArray(complementary_readings)) {
        const { editedIndex } = complementary_reading;
        if (editedIndex !== undefined) {
          this.form.complementary_readings.splice(
            editedIndex,
            1,
            complementary_reading
          );
        } else {
          this.form.complementary_readings = [
            ...complementary_readings,
            complementary_reading
          ];
        }
      } else {
        this.form.complementary_readings = [this.form.complementary_reading];
      }
      this.form.complementary_reading = {
        title: "",
        site_name: "",
        url: "",
        editedIndex: undefined
      };
      this.visible.complementary_reading = false;
    },
    onEditReading(reading, editedIndex) {
      this.form.complementary_reading = {
        ...reading,
        editedIndex
      };
      this.visible.complementary_reading = true;
    },
    onFileChange(files) {
      const formData = new FormData();

      if (!files) return;

      if (files.length > 1) {
        files.forEach((f, i) => {
          formData.append("photo", f, f.name);
        });
      } else {
        formData.set("photo", files[0], files[0].name);
      }

      this.form.complementary_files = formData.getAll("photo");
    },
    onRemoveFile(file, index) {
      this.form.complementary_files = this.form.complementary_files.filter(
        (f, i) => i !== index
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.view-product-register-module-quiz {
  h5 {
    display: flex;
    align-items: center;
    i {
      font-size: 28px;
    }
  }
}
</style>
